import { render, staticRenderFns } from "./CowsNosePunching2.vue?vue&type=template&id=0aaf9dd7&scoped=true&"
import script from "./CowsNosePunching2.vue?vue&type=script&lang=js&"
export * from "./CowsNosePunching2.vue?vue&type=script&lang=js&"
import style0 from "./CowsNosePunching2.vue?vue&type=style&index=0&id=0aaf9dd7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aaf9dd7",
  null
  
)

export default component.exports